/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontWebSongModel
 */
export interface FrontWebSongModel {
    /**
     * 
     * @type {number}
     * @memberof FrontWebSongModel
     */
    id: number;
    /**
     * Interpret
     * @type {string}
     * @memberof FrontWebSongModel
     */
    interpret: string;
    /**
     * Název skladby
     * @type {string}
     * @memberof FrontWebSongModel
     */
    song: string;
    /**
     * Začátek skladby
     * @type {string}
     * @memberof FrontWebSongModel
     */
    beginAt: string;
    /**
     * Začátek skladby
     * @type {string}
     * @memberof FrontWebSongModel
     */
    endAt: string;
    /**
     * Obrázek
     * @type {string}
     * @memberof FrontWebSongModel
     */
    image: string;
    /**
     * Aktivní
     * @type {boolean}
     * @memberof FrontWebSongModel
     */
    active?: boolean;
    /**
     * Má text (slug radia pro ziskani textu)
     * @type {string}
     * @memberof FrontWebSongModel
     */
    lyricsRadioSlug: string;
}

/**
 * Check if a given object implements the FrontWebSongModel interface.
 */
export function instanceOfFrontWebSongModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "interpret" in value;
    isInstance = isInstance && "song" in value;
    isInstance = isInstance && "beginAt" in value;
    isInstance = isInstance && "endAt" in value;
    isInstance = isInstance && "image" in value;
    isInstance = isInstance && "lyricsRadioSlug" in value;

    return isInstance;
}

export function FrontWebSongModelFromJSON(json: any): FrontWebSongModel {
    return FrontWebSongModelFromJSONTyped(json, false);
}

export function FrontWebSongModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontWebSongModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'interpret': json['interpret'],
        'song': json['song'],
        'beginAt': json['beginAt'],
        'endAt': json['endAt'],
        'image': json['image'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'lyricsRadioSlug': json['lyricsRadioSlug'],
    };
}

export function FrontWebSongModelToJSON(value?: FrontWebSongModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'interpret': value.interpret,
        'song': value.song,
        'beginAt': value.beginAt,
        'endAt': value.endAt,
        'image': value.image,
        'active': value.active,
        'lyricsRadioSlug': value.lyricsRadioSlug,
    };
}

